const WORDS = ["Adventure", "Meditation", "Action", "Poetry", "Stories", "Stillness"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.concat(WORDS).map((w, i) => (
      <span key={i} className="flex items-center font-serif text-3xl tracking-wide text-[#F4F4F0]/35 md:text-5xl">
        <span className={i % 2 ? "px-8 italic" : "px-8"}>{w}</span>
        <span className="text-lg text-[#E63946]/70">—</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#0C0A09] py-7">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
